import { render, staticRenderFns } from "./ClientEmailEventsModal.vue?vue&type=template&id=1d765e1c&scoped=true&"
import script from "./ClientEmailEventsModal.vue?vue&type=script&lang=js&"
export * from "./ClientEmailEventsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientEmailEventsModal.vue?vue&type=style&index=0&id=1d765e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d765e1c",
  null
  
)

export default component.exports